import dynamic from 'next/dynamic';

const BookingRangeSliderDynamic = dynamic(() => import('./BookingRangeSlider'));

export default BookingRangeSliderDynamic;
